<div *ngIf="enabled">
    <ol class="breadcrumb">
        <ng-template ngFor let-url [ngForOf]="template" let-first="first" let-last="last">
            <li class="breadcrumb-item" [ngClass]="{'active': last }">
                <a (click)="!last && router.navigate([url.route])">{{url.title | translate}}</a></li>
        </ng-template>
    </ol>
</div>